export const formatPrice = (price: number, currency: string, locale?: string): string => {
    const formatter = new Intl.NumberFormat(locale || 'en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return formatter.format(price);
};
